// extracted by mini-css-extract-plugin
export default {"img":"Home_img__HY38c"};